module.exports = __webpack_public_path__ + "static/media/twIcon.9a04f5e4.png";